import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "playlistId", "playlistName", "item", "onSuccess", "showNotification", "onClick", "use"];
import Raven from 'raven-js';
import { useAddToPlaylist } from '../savedItemsQueries';
import { Button } from 'foundations-components/transitional/components/Button';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import RouterButton from 'ui-addon-react-router-dom/RouterButton';
import RemoveItemFromPlaylistButton from './RemoveItemFromPlaylistButton';
import { useCatalogCardModels } from 'academy-common-lib/features/catalog/hooks/useCatalogCardModels';
import { getPlaylistUrl } from '../../playlist/playlistRouting';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { convertToSupportedLanguage } from 'academy-common-lib/constants/academySupportedLanguages';
import { toPlaylistItemType } from '../../playlistItems/playlistItemsTypes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const AddItemToPlaylistSuccessNotification = ({
  item,
  playlistName,
  playlistId
}) => {
  var _catalogCardModels$;
  // needs to retrieve the card model for the name
  // will be removed after migration
  const {
    catalogCardModels
  } = useCatalogCardModels({
    items: [item]
  });
  const itemName = (catalogCardModels === null || catalogCardModels === void 0 || (_catalogCardModels$ = catalogCardModels[0]) === null || _catalogCardModels$ === void 0 ? void 0 : _catalogCardModels$.name) || '';
  return /*#__PURE__*/_jsxs(ButtonWrapper, {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "academyCommon.savedItems.tooltips.savedToPlaylist",
      options: {
        itemName,
        playlistName
      }
    }), /*#__PURE__*/_jsx(RouterButton, {
      marginInlineStart: "400",
      size: "small",
      to: getPlaylistUrl(playlistId),
      use: "primary",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyCommon.savedItems.tooltips.viewPlaylist"
      })
    }), /*#__PURE__*/_jsx(RemoveItemFromPlaylistButton, {
      item: item,
      marginInlineStart: "300",
      playlistId: playlistId,
      playlistName: playlistName,
      use: "link",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyCommon.savedItems.tooltips.undo"
      })
    })]
  });
};
const AddItemToPlaylistButton = _ref => {
  let {
      children,
      playlistId,
      playlistName,
      item,
      onSuccess,
      showNotification = true,
      onClick,
      use = 'unstyled'
    } = _ref,
    buttonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [addToPlaylist, {
    addToPlaylistMutationLoading
  }] = useAddToPlaylist();
  const handleOnClick = e => {
    if (addToPlaylistMutationLoading) return;
    if (onClick) onClick(e);
    const playlistItemType = toPlaylistItemType(item.type);
    if (!playlistItemType) {
      Raven.captureMessage('Content type cannot be added to playlist', {
        extra: {
          item
        }
      });
      FloatingAlertStore.addAlert({
        message: I18n.text('academyCommon.savedItems.alerts.playlistItemTypeNotSupported'),
        type: 'danger'
      });
      return;
    }
    addToPlaylist({
      playlistId,
      itemId: item.id,
      language: convertToSupportedLanguage(item.language),
      type: playlistItemType
    }).then(() => {
      if (showNotification) {
        FloatingAlertStore.addAlert({
          message: /*#__PURE__*/_jsx(AddItemToPlaylistSuccessNotification, {
            item: item,
            playlistId: playlistId,
            playlistName: playlistName
          }),
          type: 'success'
        });
      }
      onSuccess === null || onSuccess === void 0 || onSuccess();
    }).catch(() => {
      if (showNotification) {
        FloatingAlertStore.addAlert({
          message: I18n.text('academyCommon.savedItems.tooltips.saveToPlaylistError'),
          type: 'danger'
        });
      }
      Raven.captureMessage('Achievements: error adding item to playlist', {
        extra: {
          playlistId,
          item
        }
      });
    });
  };
  return /*#__PURE__*/_jsx(Button, Object.assign({}, buttonProps, {
    onClick: handleOnClick,
    use: use,
    children: children
  }));
};
export default AddItemToPlaylistButton;